// Light / dark theme. The choice is stored in localStorage ("pcg_theme") and applied as
// html[data-theme="dark"]; pages/_document.js applies it before first paint, theme-pink.css does the rest.
export function toggleTheme() {
  const root = document.documentElement;
  const dark = root.getAttribute("data-theme") !== "dark";
  if (dark) root.setAttribute("data-theme", "dark");
  else root.removeAttribute("data-theme");
  try {
    window.localStorage.setItem("pcg_theme", dark ? "dark" : "light");
  } catch (e) {
    // storage blocked: the theme still switches for this page view
  }
  if (window.gtag) window.gtag("event", "theme_switch", { theme: dark ? "dark" : "light" });
}

// Sun / moon glyphs (currentColor). Both are rendered; CSS shows the one for the current theme.
export const MOON_PATH = "M20.5 14.6 A8.6 8.6 0 1 1 9.4 3.5 A7 7 0 0 0 20.5 14.6 Z";
export const SUN_PATH = "M12 7.2 A4.8 4.8 0 1 0 12 16.8 A4.8 4.8 0 1 0 12 7.2 Z M12 1.8 V4.2 M12 19.8 V22.2 M1.8 12 H4.2 M19.8 12 H22.2 M4.8 4.8 L6.5 6.5 M17.5 17.5 L19.2 19.2 M4.8 19.2 L6.5 17.5 M17.5 6.5 L19.2 4.8";
